// node modules
import React from 'react';
import { observer } from 'mobx-react';
// ui library
import { View, Loading } from '@upstox/upstox-ui';
import { useStore } from 'modules/Stores';
// style
import * as css from './style';

type Props = ViewProps & {
  height?: number;
  loadingKey: LoadingKey;
  childKey?: string;
};

const LoadingProvider: React.FC<Props> = ({
  height,
  children,
  loadingKey,
  childKey,
  ...props
}) => {
  const { getLoading, getChildLoading } = useStore('LoadingStore');

  const loadingValue = childKey
    ? getChildLoading(loadingKey, childKey)
    : getLoading(loadingKey);

  const isLoading = typeof loadingValue !== 'undefined' ? loadingValue : true;

  return isLoading ? (
    <View
      flex
      justifyContent="center"
      alignItems="center"
      css={css.container}
      cssProps={{ height }}
      {...props}
    >
      <Loading />
    </View>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

export default observer(LoadingProvider);
